import React, { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import FlexGroup from 'components/FlexGroup';
import moment from 'moment';
import Pagination, { Refresh, TotalCount } from 'components/Pagination';
import PageSizeSelect from 'components/Pagination/PageSizeSelect';
import AuthFeature from 'components/AuthFeature';
import { Translate } from 'react-redux-i18n';
import Period from 'components/Period';
import { AUTH_CREATE_LINK_PAY } from 'constants/permission';
import headerConfig from './ListHeader';
import ListRow from './ListRow';
import ListView from 'components/ListView';
import CreateLinkPay from "./CreateLinkPay";

const ListItem = ({ columns, rowData }) => {
    return (
        <ListRow
            key={ `nonusercharge-${ rowData.link_pay_id }` }
            columns={ columns }
            data={ rowData }
        />
    )
};

const NonUserChargeList = ({
    onChange,
    onFetch,
    onSort,
    onSelect,
    onModalOpen,
    fromTime,
    toTime,
    data,
}) => {
    const [responseTime, setResponseTime] = useState(Date.now());
    const [showCreate, setShowCreate] = useState(false);

    const {
        data_list,
        page_count,
        page_index,
        size: pageSize,
        total,
        updatedTime,
    } = data;

    useEffect(() => {
        if (updatedTime > responseTime) {
            setResponseTime(updatedTime);
        }
    }, [responseTime, updatedTime]);

    const handleModalOpen = (value, pollingInterval) => {
        setShowCreate(value);
        onModalOpen(pollingInterval);
    }

    return (
        <section className="list-view-wrap">
            <FlexGroup spaceBetween className="pagination-control-sec">
                <FlexGroup>
                    <AuthFeature requiredList={ [AUTH_CREATE_LINK_PAY] }>
                        <Button
                            className="new-btn"
                            outline
                            type="button"
                            onClick={ () => handleModalOpen(true, 0) }
                        >
                            <Translate value="nonuser_charge.new" />
                        </Button>
                    </AuthFeature>
                    <Pagination
                        page={ page_index }
                        total={ page_count }
                        offset={ pageSize }
                        onSelect={ onSelect }
                    />
                    <div className="page-size-select">
                        <PageSizeSelect
                            onChange={ selection => onChange(selection.value) }
                        />
                    </div>
                    <TotalCount count={ total } />
                    <Period fromTime={ fromTime } toTime={ toTime } />
                </FlexGroup>
                <Refresh time={ moment(responseTime) } onClick={ onFetch } />
            </FlexGroup>
            <ListView
                rowHeight={ 56 }
                header={ headerConfig }
                onSort={ onSort }
                list={ data_list }
                renderListRow={ ListItem }
                dataKey="link_pay_id"
            />
            <CreateLinkPay
                show={ showCreate }
                onClose={ () => handleModalOpen(false, 6000) }
            />
        </section>
    );
};

NonUserChargeList.propTypes = {
    onChange: PropTypes.func,
    onFetch: PropTypes.func,
    onSort: PropTypes.func,
    onSelect: PropTypes.func,
    onModalOpen: PropTypes.func,
    fromTime: PropTypes.oneOfType([
        PropTypes.instanceOf(moment),
        PropTypes.string,
    ]),
    toTime: PropTypes.oneOfType([
        PropTypes.instanceOf(moment),
        PropTypes.string,
    ]),
    data: PropTypes.shape({
        data_list: PropTypes.arrayOf(PropTypes.shape({})),
        page_count: PropTypes.number,
        page_index: PropTypes.number,
        size: PropTypes.number,
        total: PropTypes.number,
        updatedTime: PropTypes.oneOfType([
            PropTypes.instanceOf(moment),
            PropTypes.number,
        ]),
    }),
};
NonUserChargeList.defaultProps = {
    onChange: () => {},
    onFetch: () => {},
    onSort: () => {},
    onSelect: () => {},
    onModalOpen: () => {},
    fromTime: undefined,
    toTime: undefined,
    data: {},
};
export default NonUserChargeList;
